import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d6e4e14"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "代理商子渠道管理", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "checkbox-tips" }, "子会员将要推广的业务", -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode("保存添加的账号")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("保存修改的账号")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("重新填写")
const _hoisted_7 = { style: {"margin-left":"10px","color":"red"} }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("修改")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tips = _resolveComponent("Tips")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_checkbox_button = _resolveComponent("el-checkbox-button")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_MainLayout = _resolveComponent("MainLayout")!

  return (_openBlock(), _createBlock(_component_MainLayout, null, {
    default: _withCtx(() => [
      _createVNode(_component_Tips, { msg: "您可以添加子渠道或者操作子渠道。" }),
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", {
          class: "addBtn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.dialogFormVisible = true; _ctx.dialogType = 'add'})
        }, "添加子渠道")
      ]),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.dialogFormVisible,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.dialogFormVisible) = $event)),
        title: _ctx.dialogType === 'add' ? '添加子渠道' : '修改子渠道'
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form, {
            ref: "secondaryFormRef",
            model: _ctx.secondaryForm,
            rules: _ctx.secondaryFormRules,
            "label-position": "right",
            "label-width": "120px"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: "账户名：",
                prop: "name"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.secondaryForm.name,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.secondaryForm.name) = $event)),
                    disabled: _ctx.dialogType === 'change' ? true : false,
                    placeholder: "子会员登录的用户名，如：test_1001"
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "密码：",
                prop: "password"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.secondaryForm.password,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.secondaryForm.password) = $event)),
                    placeholder: "子会员登录的密码，由6-12位英文、数字组成，如：123456"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "推广业务：",
                prop: "softs"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_checkbox_group, {
                    modelValue: _ctx.secondaryForm.softs,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.secondaryForm.softs) = $event))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.channelSoftInfos, (item) => {
                        return (_openBlock(), _createBlock(_component_el_checkbox_button, {
                          key: item.softid,
                          label: item.softid
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.softname), 1)
                          ]),
                          _: 2
                        }, 1032, ["label"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "渠道号：",
                prop: "indexs"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.secondaryForm.indexs,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.secondaryForm.indexs) = $event)),
                    placeholder: "如：1001或1002,1003或1002-1010；会员获取的渠道ID，若有多个，请用半角逗号或短划线隔开"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [
                  (_ctx.dialogType === 'add')
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        type: "primary",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.addSecondary()))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_4
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.dialogType === 'change')
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 1,
                        type: "primary",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.changeSecondary()))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_5
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.dialogType === 'add')
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 2,
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.resetForm()))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_6
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_button, {
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.dialogFormVisible = false))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.dialogType === 'add' ? '放弃添加' : '放弃修改'), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ]),
        _: 1
      }, 8, ["modelValue", "title"]),
      _createVNode(_component_el_table, {
        data: _ctx.secondaryTableData,
        style: {"width":"100%"},
        stripe: "",
        border: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "username",
            label: "账号"
          }),
          _createVNode(_component_el_table_column, {
            prop: "password",
            label: "密码"
          }),
          _createVNode(_component_el_table_column, {
            prop: "softs",
            label: "推广业务"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("span", null, _toDisplayString(scope.row.softsString), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "indexs",
            label: "渠道号"
          }),
          _createVNode(_component_el_table_column, {
            prop: "enable",
            label: "状态"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("span", _hoisted_7, _toDisplayString(scope.row.enable ? '允许' : '禁止'), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, { label: "操作" }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_button, {
                size: "mini",
                type: "success",
                onClick: ($event: any) => (_ctx.modifySecondary(scope.$index, scope.row))
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_button, {
                size: "mini",
                type: "success",
                onClick: ($event: any) => (_ctx.changState(scope.$index, scope.row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(scope.row.enable ? '禁止' : '允许'), 1)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"]),
      _createElementVNode("div", null, [
        _createVNode(_component_el_pagination, {
          align: "left",
          background: "",
          layout: "prev, pager, next",
          "current-page": _ctx.paginationHandle.page,
          total: _ctx.paginationHandle.total,
          onCurrentChange: _ctx.paginationHandle.handleCurrentChange
        }, null, 8, ["current-page", "total", "onCurrentChange"])
      ])
    ]),
    _: 1
  }))
}